import React, { useEffect, useState } from "react";
import { Col, Input, Modal, Row, Image, Divider, Tooltip } from "antd";
import Button from "@mui/material/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Message from "../common/Message";
import AuthService from "../auth/AuthService";
import config from "../config";
import { useSelector } from "react-redux";
import { CloseOutlined } from "@ant-design/icons";
import { Checkbox } from "antd";

const Auth = new AuthService();

const ReportModal = ({
  isModalOpen,
  setIsModalOpen,
  selectedDefectItem,
  setAllDefectsSheet,
  allDefectsSheet,
  setFiles,
  files,
  setDeletedFiles,
  deletedFiles,
  uploadedFilesTemp,
  setUploadedFilesTemp,
}) => {
  const { selectedRoute } = useSelector((state) => state?.AppState?.driverData);
  const { TextArea } = Input;
  const [isLoading, setIsLoading] = React.useState(false);
  const [driveCheck, setDriveCheck] = React.useState(false);
  const [loadMessage, setLoadMessage] = React.useState("");
  const [type, setType] = React.useState("info");
  const [notes, setNotes] = useState("");
  const [currentItemFiles, setCurrentItemFiles] = React.useState([]);

  useEffect(() => {
    if (selectedDefectItem) {
      setNotes(selectedDefectItem.notes ? selectedDefectItem.notes : "");
      setDriveCheck(selectedDefectItem.not_road_worthy);
      setCurrentItemFiles(
        selectedDefectItem.images ? selectedDefectItem.images : []
      );
    }
  }, [selectedDefectItem]);

  const handleDeleteUploadedFile = (fileNameToDelete) => {
    setUploadedFilesTemp((prevUploadedFilesTemp) => {
      const updatedFiles = prevUploadedFilesTemp[
        selectedDefectItem.key
      ]?.filter((file) => file.name !== fileNameToDelete);
      return {
        ...prevUploadedFilesTemp,
        [selectedDefectItem.key]: updatedFiles,
      };
    });
    const updatedFilesList = files.filter(
      (file) => file.name !== fileNameToDelete
    );
    setFiles(updatedFilesList);
    handleDeleteCurrentFile(fileNameToDelete);
  };

  const updateValues = () => {
    const updatedDefects = allDefectsSheet.map((defect) =>
      defect.id === selectedDefectItem.id
        ? {
            ...defect,
            notes: notes,
            images: currentItemFiles,
            not_road_worthy: driveCheck,
          }
        : defect
    );
    setAllDefectsSheet(updatedDefects);
  };

  const onChangeDefect = (e, type) => {
    let allDefectsSheet1 = allDefectsSheet;
    let currentDefectItem = allDefectsSheet1.filter(
      (d) => d.id == selectedDefectItem.id
    );
    if (currentDefectItem.length > 0) {
      if (type == "notes") {
        currentDefectItem[0].notes = e.target.value;
        setNotes(e.target.value);
      }
      setAllDefectsSheet(allDefectsSheet1);
    }
  };

  const handleOk = () => {
    setIsModalOpen(false);
    updateValues();
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleSubmitImage = (e) => {
    e.preventDefault();
    let acceptedFiles = e.target.files;

    setIsLoading(true);
    for (let file of acceptedFiles) {
      const randomString = Math.random().toString(36).substring(2, 10);
      const newFileName = `${file.name.split(".")[0]}-${randomString}.${
        file.name.split(".")[1]
      }`;
      setLoadMessage("");
      let files1 = files;
      files1.push({
        name: newFileName,
        display_name: newFileName,
        file: file,
        ContentType: file.type,
      });
      setFiles(files1);
      let files2 = currentItemFiles;
      files2.push(newFileName);
      setCurrentItemFiles(files2);
      updateValues();

      const updatedUploadedFilesTemp = { ...uploadedFilesTemp };
      for (const key of Object.keys(updatedUploadedFilesTemp)) {
        if (key === selectedDefectItem.key) {
          updatedUploadedFilesTemp[key] = [
            ...updatedUploadedFilesTemp[key],
            {
              name: newFileName,
              display_name: newFileName,
              file: file,
              ContentType: file.type,
            },
          ];
          setUploadedFilesTemp(updatedUploadedFilesTemp);
        }
      }
    }
  };

  const handleDeleteCurrentFile = (itemToDelete) => {
    setCurrentItemFiles(
      currentItemFiles.filter((item) => item !== itemToDelete)
    );
    if (!deletedFiles.includes(itemToDelete)) {
      setDeletedFiles((prevDeletedFiles) => [
        ...prevDeletedFiles,
        itemToDelete,
      ]);
    }
    updateValues();
  };

  return (
    <>
      {selectedDefectItem && (
        <>
          <Modal
            width={800}
            open={isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            title={selectedDefectItem?.title}
            cancelButtonProps={{ style: { display: "none" } }}
          >
            <Divider style={{ margin: 5 }} />
            <h4
              style={{ fontWeight: "bold", marginBottom: "3px", marginTop: 0 }}
            >
              Advisories
            </h4>
            <div>
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} md={8} lg={8} xl={6}>
                  <TextArea
                    autoSize={{ minRows: 3, maxRows: 6 }}
                    label="Notes"
                    placeholder="Enter Any Specific Notes"
                    value={notes}
                    onChange={(e) => onChangeDefect(e, "notes")}
                  />
                </Col>
                <Col xs={24} sm={12} md={8} lg={8} xl={6}>
                  <Checkbox
                    checked={driveCheck}
                    onChange={(e) => {
                      setDriveCheck(e.target.checked);
                    }}
                    size="large"
                  >
                    Not Road Worthy
                  </Checkbox>
                </Col>
              </Row>
            </div>
            <div>
              <Button
                component="label"
                variant="contained"
                sx={{ marginTop: "10px" }}
                startIcon={<CloudUploadIcon />}
              >
                Add files
                <input
                  type="file"
                  hidden
                  multiple
                  accept="image/*, video/*"
                  onChange={(e) => {
                    handleSubmitImage(e);
                  }}
                />
              </Button>
            </div>
            <Divider />
            <h4>CurrentFiles</h4>
            <div style={{ overflowX: "auto" }}>
              <Image.PreviewGroup
                preview={{
                  onChange: (current, prev) =>
                    console.log(
                      `current index: ${current}, prev index: ${prev}`
                    ),
                }}
              >
                <div style={{ display: "flex" }}>
                  {currentItemFiles.length > 0 &&
                    currentItemFiles
                      .filter(
                        (item) => !files.some((file) => file.name === item)
                      )
                      .map((item) => {
                        const imageUrl = `${config.tms_uploads_cdn}/${config.env}/defect_sheets/${selectedRoute}/${item}`;
                        return (
                          <div
                            style={{
                              position: "relative",
                              marginRight: "10px",
                              marginBottom: "10px",
                            }}
                          >
                            <Image
                              width={200}
                              height={125}
                              alt="uploaded Images"
                              style={{
                                padding: "5px",
                                border: "1px solid lightgrey",
                              }}
                              src={imageUrl}
                            />
                            <CloseOutlined
                              style={{
                                fontSize: "25px",
                                position: "absolute",
                                right: 5,
                                top: 5,
                                color: "#c12828",
                              }}
                              onClick={() => handleDeleteCurrentFile(item)}
                            />
                          </div>
                        );
                      })}
                </div>
              </Image.PreviewGroup>
            </div>
            <Divider />
            {uploadedFilesTemp[selectedDefectItem.key]?.length > 0 && (
              <h4>New Files</h4>
            )}
            <div style={{ overflowX: "auto" }}>
              <Image.PreviewGroup
                preview={{
                  onChange: (current, prev) =>
                    console.log(
                      `current index: ${current}, prev index: ${prev}`
                    ),
                }}
              >
                <div style={{ display: "flex" }}>
                  {uploadedFilesTemp[selectedDefectItem.key]?.length > 0 &&
                    uploadedFilesTemp[selectedDefectItem.key]?.map((files) => (
                      <div
                        style={{
                          position: "relative",
                          marginRight: "10px",
                          marginBottom: "10px",
                        }}
                      >
                        <Image
                          width={200}
                          height={150}
                          style={{
                            padding: "5px",
                            border: "1px solid lightgrey",
                          }}
                          src={URL.createObjectURL(files.file)}
                        />
                        <Tooltip title="Delete">
                          <CloseOutlined
                            style={{
                              fontSize: "30px",
                              position: "absolute",
                              right: 5,
                              top: 5,
                              color: "#c12828",
                            }}
                            onClick={() => handleDeleteUploadedFile(files.name)}
                          />
                        </Tooltip>
                      </div>
                    ))}
                </div>
              </Image.PreviewGroup>
            </div>
          </Modal>
          <Message type={type} msg={loadMessage} />
        </>
      )}
    </>
  );
};

export default ReportModal;
